import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../../models/mensagem';
import { MensagemProvider } from '../../../providers/mensagem/mensagem';
import { EmpresaLocalProvider } from '../../../providers/empresa-local/empresa-local';
import { Content } from 'ionic-angular';
import { BrComService } from '../../../service/BrComService';
import { FotoProvider } from '../../../providers/foto/foto';
import { ServidorProvider } from '../../../providers/servidor/servidor';

export abstract class Conversa {

    protected empresa: any;
    // usado para resolver um bug do ionic infinity scroll
    // https://github.com/ionic-team/ionic/issues/12309
    private fazendoScrollBottom: boolean;

    constructor(protected mensagemProvider: MensagemProvider,
        protected empresaLocalProvider: EmpresaLocalProvider,
        protected brComService: BrComService,
        protected fotoProvider: FotoProvider) {
        this.empresa = this.empresaLocalProvider.getEmpresa();
    }

    protected abstract criarMensagemSimplesEnvio(textoMensagem: string, idUsuarioDestino: number);

    protected abstract criarMensagemImagemEnvio(idUsuarioDestino: number): Mensagem;

    protected abstract criarMensagemArquivoEnvio(idUsuarioDestino: number, arquivo: ArquivoMensagem);

    protected scrollBottom(content: Content) {
        try {
            if (!this.fazendoScrollBottom) {
                this.fazendoScrollBottom = true;
                setTimeout(() => {
                    content.scrollToBottom().then(
                        () => {
                            this.fazendoScrollBottom = false;
                        }
                    )
                  }, 50);
            }
        } catch (error) {
            this.fazendoScrollBottom = false;
        }
    }

    protected obterImagemComHash(hash: string): string {
        if (hash) {
            return this.fotoProvider.getUrlImagemServidor(hash);
        }
        return "assets/img/usuario.png";
    }

    protected abrirArquivo(link: string): void {
        if (link && link !== "") {
            this.brComService.abrePaginaNoBrowser(`https://docs.google.com/viewer?url=${link}`);
        }
    }

    protected isUploadingArquivo(mensagem: Mensagem) {
        return !mensagem.arquivo.link && mensagem.arquivo.link === '';
    }

    protected abrirLink(link: string) {
        if (link && link !== "") {
            window.open(link, '_blank');
          }
    }

    protected async abrirLinkHTML(hashHTML: string): Promise<void> {
        const link = `${ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE}/msg/${hashHTML}.html`;
        this.brComService.abrePaginaComTipoURL(link);
    }

    protected getTimestamp(): number {
        return Math.floor(Date.now() / 1000);
    }
}


// WEBPACK FOOTER //
// ./src/pages/shared/conversa/conversa.ts